import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { useGoogleConsent } from "@/hooks/useGoogleConsent";
import { trackButtonClickGA } from "@/lib/analytics";
import { isPostHogDisabledPath } from "@/lib/posthogPathGuard";
import { isAdminShellPath } from "@/lib/geoConsentRoutes";
import {
  getCookieConsentDelayMs,
  shouldHidePublicConsentDock,
} from "@/lib/consentSurfaces";

const ConsentDock = lazy(() =>
  import("@/components/ConsentDock").then((module) => ({
    default: module.ConsentDock,
  })),
);

/**
 * Consentimientos del sitio público (GDPR cookies + geolocalización AR) en un
 * único dock flotante (ConsentDock) + GA consent restore. No corre en admin.
 */
export function PublicSiteCookieConsent() {
  const { pathname } = useLocation();
  useGoogleConsent();

  // On DualCTA / hero funnels the fixed consent dock competes with the primary CTA.
  if (
    isPostHogDisabledPath(pathname) ||
    isAdminShellPath(pathname) ||
    shouldHidePublicConsentDock(pathname)
  ) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ConsentDock
        cookieDelayMs={getCookieConsentDelayMs(pathname)}
        onAccept={() =>
          trackButtonClickGA(
            "COOKIE_CONSENT_ACCEPTED",
            "site",
            "gdpr_compliance",
            "privacy",
          )
        }
        onDecline={() =>
          trackButtonClickGA(
            "COOKIE_CONSENT_DECLINED",
            "site",
            "gdpr_compliance",
            "privacy",
          )
        }
        onManage={() =>
          trackButtonClickGA(
            "COOKIE_PREFERENCES_MANAGE",
            "site",
            "gdpr_compliance",
            "privacy",
          )
        }
      />
    </Suspense>
  );
}
